import { ComponentProps, PropsWithChildren, ReactNode } from 'react';
import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
} from './BaseFormComponents';

export type BaseFormFieldWrapperProps = {
  labelProps?: ComponentProps<typeof FormLabel>;
  descriptionProps?: ComponentProps<typeof FormDescription>;
  hideError?: boolean;
  description?: string;
  label?: string | ReactNode;
  formControlProps?: ComponentProps<typeof FormControl>;
  formMessageProps?: ComponentProps<typeof FormMessage>;
};

const BaseFormFieldWrapper = ({
  labelProps,
  descriptionProps,
  formMessageProps,
  formControlProps,
  label,
  description,
  hideError,
  children,
}: PropsWithChildren<BaseFormFieldWrapperProps>) => {
  return (
    <FormItem className="flex w-full flex-col gap-1">
      {typeof label === 'string' || typeof label === 'number' ? (
        <FormLabel
          {...labelProps}
          className="text-primary text-sm leading-[18px] font-[500]"
        >
          <div className="flex items-center gap-2">{label}</div>
        </FormLabel>
      ) : (
        label
      )}
      <FormControl {...formControlProps}>{children}</FormControl>
      {description && (
        <FormDescription className="text-xs" {...descriptionProps}>
          {description}
        </FormDescription>
      )}
      {!hideError && <FormMessage {...formMessageProps} />}
    </FormItem>
  );
};

export { BaseFormFieldWrapper };
